import { FC, ReactNode } from 'react';
import { FormProvider } from 'react-hook-form';
import { useNoteReceivableForm } from '../hooks';
import { NoteReceivableFormContextProvider } from '../context';

interface NoteReceivableFormProps {
  children?: ReactNode;
  className?: HTMLFormElement['className'];
  useNoteReceivableFormReturn: ReturnType<typeof useNoteReceivableForm>;
}

export const NoteReceivableForm: FC<NoteReceivableFormProps> = ({
  children,
  className,
  useNoteReceivableFormReturn,
}) => {
  if (!useNoteReceivableFormReturn) {
    return null;
  }

  const { formMethods, noteReceivable, householdID, onSubmit } = useNoteReceivableFormReturn;

  if (!formMethods) {
    return null;
  }

  return (
    <FormProvider {...formMethods}>
      <NoteReceivableFormContextProvider noteReceivable={noteReceivable} householdID={householdID}>
        <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)} role={'form'}>
          {children}
        </form>
      </NoteReceivableFormContextProvider>
    </FormProvider>
  );
};
